import { render } from "./richtextedit.vue?vue&type=template&id=e0ce21c6"
import script from "./richtextedit.vue?vue&type=script&lang=js"
export * from "./richtextedit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__